import { OverlayPage } from '@client/components/_core/layout/OverlayPage';
import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { trpc } from '@client/trpc/client';
import { createFileRoute } from '@tanstack/react-router';
import { Skeleton } from 'antd';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/product-types/financials/$id')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Sections',
        },
    },
    params: {
        parse({ id }) {
            return {
                id: BigInt(id),
            };
        },
    },
    component: FinancialsConfiguration,
});

function FinancialsConfiguration() {
    const { id } = Route.useParams();
    const { data, isPending } = trpc.productType.getProductType.useQuery({ id });
    const navigate = useNavigate();

    return (
        <PageController route={Route}>
            <OverlayPage
                loading={isPending}
                title={isPending ? <Skeleton.Node active className="h-6 w-60" /> : `Claim financials - ${data?.name}`}
                size="large"
                afterClose={() => navigate({ moveInMatches: -1 })}
            >
                <Tabs
                    items={[
                        {
                            to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections',
                            label: 'Sections',
                        },
                        {
                            to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types',
                            label: 'Transaction types',
                        },
                        {
                            to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes',
                            label: 'Cost codes',
                        },
                        {
                            to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax',
                            label: 'Tax',
                        },
                    ]}
                />
            </OverlayPage>
        </PageController>
    );
}
